import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const StyledModalDetails = styled.p`
    ${setFontVariant("body1")}
    line-height: 20px;
    margin: 16px 0 0 0;
`;

export const modalStyles = { content: { width: 400, height: 240, padding: "20px 16px 16px 24px" } };

export const titleStyles = { marginBottom: "20px" };

export const detailsStyles = { margin: "0 0 12px" };
